/*
 * Project: LegalPlace assistant
 * File: src\logic\autosave.js
 * Author: Amine Azizi
 * Version: 1.0
 */
import Cookies from 'universal-cookie';

import { getAllOptions } from './ovc_converter';
import lpevents from '../tracking/lpevents';
import lpApp from '../app/lp_app';


export const removeAutoSaveCookiesWP = () => {
  const cookies = new Cookies();
  const hostname = window.location.hostname
  const hostProd = 'legalplace.fr'
  const hostStaging = 'legalplace.eu'
  const hostLocal = 'localhost'
  const origin = hostname.indexOf(hostProd) > -1 ? `.${hostProd}` : hostname.indexOf(hostStaging) > -1 ? `.${hostStaging}` : hostLocal
  cookies.remove('autoSave', { path: '/', domain: origin});
}

function autosave() {
  if (!lpApp.isPayed) {
    if (typeof Storage !== 'function') return false;

    // Document data
    const data = getAllOptions();
    const dataStringified = JSON.stringify(data);

    const checkout = (lpApp.getState().appstate === 2);
    const modelParams = lpApp.references.customs.custom;

    // Contract's uniqid
    let contractUniqid = false;
    if (typeof (lpApp.contractUniqid) === 'string' && lpApp.contractUniqid.length > 0) ({ contractUniqid } = lpApp);
    if (!contractUniqid && typeof (lpApp.getState().checkout_operations.contract_id) === 'string' && lpApp.getState().checkout_operations.contract_id.length > 0) contractUniqid = lpApp.getState().checkout_operations.contract_id;

    // Document info
    const info = {
      permalink: lpApp.contractTitle,
      save_on: new Date().getTime(),
      title: lpApp.getState().contract.name,
      section: 1 + lpApp.getState().contract.currentSection,
      contract_id: contractUniqid,
      checkout,
    };

    // Bar wording
    if (typeof (modelParams) !== 'undefined' && typeof (modelParams.reprise) !== 'undefined') {
      info.barWording = modelParams.reprise;
    }

    const infoStringified = JSON.stringify(info);
    // HERE DELETE COOKIES of autoSAve (SIV and others apps)
    removeAutoSaveCookiesWP()

    // disable autosave
    // window.localStorage.setItem('autosave_data', dataStringified);
    // window.localStorage.setItem('autosave_info', infoStringified);
  }
}

function checkAutosave() {
  if (typeof Storage !== 'function') return false;

  const dataStringified = window.localStorage.getItem('autosave_data');
  const infoStringified = window.localStorage.getItem('autosave_info');

  if (dataStringified && infoStringified) {
    const data = JSON.parse(dataStringified);
    const info = JSON.parse(infoStringified);

    // Checking for title
    if (info.title !== lpApp.getState().contract.name) return false;

    // Checking section
    if (typeof info.section === 'undefined') return false;

    // Tracking on lpevents
    if (typeof (lpevents) !== 'undefined') lpevents.track('Continue on autosave');

    // Removing current info
    window.localStorage.removeItem('autosave_data');
    window.localStorage.removeItem('autosave_info');

    return {
      data,
      info,
    };
  }

  return false;
}

export { autosave, checkAutosave };



// WEBPACK FOOTER //
// ./src/logic/autosave.js